module.exports = __webpack_public_path__ + "static/img/Fasting_blood_sugar.f8cd5d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Fasting_blood_sugar.jpg
// module id = Rn6S
// module chunks = 7